/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { RegistrationMode } from './RegistrationMode';
import {
    RegistrationModeFromJSON,
    RegistrationModeFromJSONTyped,
    RegistrationModeToJSON,
    RegistrationModeToJSONTyped,
} from './RegistrationMode';
import type { RegistrationFeeType } from './RegistrationFeeType';
import {
    RegistrationFeeTypeFromJSON,
    RegistrationFeeTypeFromJSONTyped,
    RegistrationFeeTypeToJSON,
    RegistrationFeeTypeToJSONTyped,
} from './RegistrationFeeType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateSeasonRequest
 */
export interface UpdateSeasonRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateSeasonRequest
     */
    seasonId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdateSeasonRequest
     */
    name: string;
    /**
     * 
     * @type {RegistrationMode}
     * @memberof UpdateSeasonRequest
     */
    registrationMode: RegistrationMode;
    /**
     * 
     * @type {RegistrationFeeType}
     * @memberof UpdateSeasonRequest
     */
    registrationFeeType: RegistrationFeeType;
    /**
     * 
     * @type {number}
     * @memberof UpdateSeasonRequest
     */
    additionalFee: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSeasonRequest
     */
    chargeRegistrationFee: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateSeasonRequest
     */
    registrationFee: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSeasonRequest
     */
    hideOnLiveSchedule: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSeasonRequest
     */
    prorateTuition: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSeasonRequest
     */
    isActive: boolean;
    /**
     * 
     * @type {any}
     * @memberof UpdateSeasonRequest
     */
    seasonStartDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateSeasonRequest
     */
    seasonEndDate?: any | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof UpdateSeasonRequest
     */
    tuition?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateSeasonRequest
     */
    onlineRegistrationStartDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateSeasonRequest
     */
    onlineRegistrationEndDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateSeasonRequest
     */
    enrollmentStartDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateSeasonRequest
     */
    ageCutOfDate?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSeasonRequest
     */
    isContinuous?: boolean | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpdateSeasonRequest
     */
    tuitionRatePlanId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSeasonRequest
     */
    tuitionDiscountIds?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSeasonRequest
     */
    isFeatured?: boolean | null;
}



/**
 * Check if a given object implements the UpdateSeasonRequest interface.
 */
export function instanceOfUpdateSeasonRequest(value: object): value is UpdateSeasonRequest {
    if (!('seasonId' in value) || value['seasonId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('registrationMode' in value) || value['registrationMode'] === undefined) return false;
    if (!('registrationFeeType' in value) || value['registrationFeeType'] === undefined) return false;
    if (!('additionalFee' in value) || value['additionalFee'] === undefined) return false;
    if (!('chargeRegistrationFee' in value) || value['chargeRegistrationFee'] === undefined) return false;
    if (!('registrationFee' in value) || value['registrationFee'] === undefined) return false;
    if (!('hideOnLiveSchedule' in value) || value['hideOnLiveSchedule'] === undefined) return false;
    if (!('prorateTuition' in value) || value['prorateTuition'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function UpdateSeasonRequestFromJSON(json: any): UpdateSeasonRequest {
    return UpdateSeasonRequestFromJSONTyped(json, false);
}

export function UpdateSeasonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSeasonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'seasonId': ApiUserTasksGetPageParameterFromJSON(json['seasonId']),
        'name': json['name'],
        'registrationMode': RegistrationModeFromJSON(json['registrationMode']),
        'registrationFeeType': RegistrationFeeTypeFromJSON(json['registrationFeeType']),
        'additionalFee': json['additionalFee'],
        'chargeRegistrationFee': json['chargeRegistrationFee'],
        'registrationFee': json['registrationFee'],
        'hideOnLiveSchedule': json['hideOnLiveSchedule'],
        'prorateTuition': json['prorateTuition'],
        'isActive': json['isActive'],
        'seasonStartDate': json['seasonStartDate'] == null ? undefined : json['seasonStartDate'],
        'seasonEndDate': json['seasonEndDate'] == null ? undefined : json['seasonEndDate'],
        'tuition': json['tuition'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['tuition']),
        'onlineRegistrationStartDate': json['onlineRegistrationStartDate'] == null ? undefined : json['onlineRegistrationStartDate'],
        'onlineRegistrationEndDate': json['onlineRegistrationEndDate'] == null ? undefined : json['onlineRegistrationEndDate'],
        'enrollmentStartDate': json['enrollmentStartDate'] == null ? undefined : json['enrollmentStartDate'],
        'ageCutOfDate': json['ageCutOfDate'] == null ? undefined : json['ageCutOfDate'],
        'isContinuous': json['isContinuous'] == null ? undefined : json['isContinuous'],
        'tuitionRatePlanId': json['tuitionRatePlanId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['tuitionRatePlanId']),
        'tuitionDiscountIds': json['tuitionDiscountIds'] == null ? undefined : json['tuitionDiscountIds'],
        'isFeatured': json['isFeatured'] == null ? undefined : json['isFeatured'],
    };
}

export function UpdateSeasonRequestToJSON(json: any): UpdateSeasonRequest {
    return UpdateSeasonRequestToJSONTyped(json, false);
}

export function UpdateSeasonRequestToJSONTyped(value?: UpdateSeasonRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'seasonId': ApiUserTasksGetPageParameterToJSON(value['seasonId']),
        'name': value['name'],
        'registrationMode': RegistrationModeToJSON(value['registrationMode']),
        'registrationFeeType': RegistrationFeeTypeToJSON(value['registrationFeeType']),
        'additionalFee': value['additionalFee'],
        'chargeRegistrationFee': value['chargeRegistrationFee'],
        'registrationFee': value['registrationFee'],
        'hideOnLiveSchedule': value['hideOnLiveSchedule'],
        'prorateTuition': value['prorateTuition'],
        'isActive': value['isActive'],
        'seasonStartDate': value['seasonStartDate'],
        'seasonEndDate': value['seasonEndDate'],
        'tuition': BalanceUnitStatementEntryDebitToJSON(value['tuition']),
        'onlineRegistrationStartDate': value['onlineRegistrationStartDate'],
        'onlineRegistrationEndDate': value['onlineRegistrationEndDate'],
        'enrollmentStartDate': value['enrollmentStartDate'],
        'ageCutOfDate': value['ageCutOfDate'],
        'isContinuous': value['isContinuous'],
        'tuitionRatePlanId': ActorActivityRecordActorUserIdToJSON(value['tuitionRatePlanId']),
        'tuitionDiscountIds': value['tuitionDiscountIds'],
        'isFeatured': value['isFeatured'],
    };
}

